import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c32b828e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32b828e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c32b828e')) {
      api.createRecord('c32b828e', component.options)
    } else {
      api.reload('c32b828e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c32b828e&scoped=true&", function () {
      api.rerender('c32b828e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2776JM2YTu8JG/JS/comp/Accordion.vue"
export default component.exports